import { render, staticRenderFns } from "./PaymentMethodListItems.vue?vue&type=template&id=31bf13b4&"
import script from "./PaymentMethodListItems.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodListItems.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodListItems.vue?vue&type=style&index=0&id=31bf13b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports